import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppAbstract } from 'src/app/app.abstract';
import { FormaPagamentoEnum } from 'src/app/enuns/forma-pagamento.enum';

@Component({
  selector: 'ftc-menu-ativar',
  templateUrl: './menu-ativar.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class MenuAtivarComponent extends AppAbstract implements OnInit {
  FormaPagamentoEnum: typeof FormaPagamentoEnum = FormaPagamentoEnum;
  dados: any;
  ngOnInit(): void {
    this.dados = this._localStorageService.descriptografarDados();
    console.log(this.dados.plano.formasPagamento.indexOf('Cartão de crédito') > -1);
    console.log(this.dados.plano.formasPagamento.indexOf('Débito em conta') > -1);
    this.toggleCyberSourceScripts();
  }

  protected togglePagamento(value: FormaPagamentoEnum): void {
    this._pagamentoService.definirPagamento(value);
    this.toggleCyberSourceScripts();
  }

  public get pagamento(): string {
    return this._pagamentoService.formaPagamento;
  }

  private toggleCyberSourceScripts(): void {
    this._pagamentoService.formaPagamento === FormaPagamentoEnum.CARTAO_CREDITO
      ? this._cyberSourceService.adicionarCyberSourceScripts()
      : this._cyberSourceService.removerCyberSouceScripts();
  }
}
